import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext"; // ดึง Context การเข้าสู่ระบบ

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth(); // ตรวจสอบสถานะการเข้าสู่ระบบ

  // ถ้าไม่ได้เข้าสู่ระบบ ให้ redirect ไปหน้า Login
  return isAuthenticated ? children : <Navigate to="/" />;
};

export default PrivateRoute;
